import { CommandQueue } from "@/module/CommandQueue";
import { moduleStore } from "@/store/moduleStore";
import type { IModule } from "@/ts/module";

export const initModulesAndCommandQueue = async (modules: IModule[]) => {
	const { actions } = moduleStore.getState();
	const initPromises: Promise<void>[] = [];
	for (const mod of modules) {
		actions.addModule(mod);
		initPromises.push(mod.init());
	}

	await Promise.all(initPromises);
	new CommandQueue().init();
};
